import React, { Component } from 'react';
import { Card } from 'antd';

import DescriptionList from '@comm/DescriptionList';
import { queryFilePreview } from '@api/pub/attachment';
import ModalApportion from './ModalTable';
import ModalDetailTable from './ModalDetailTable';

const { Description } = DescriptionList;
class Open extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      detailVisible: false,
    };
  }

  componentDidMount() {}

  handleVisible = flag => {
    this.setState({
      visible: !!flag,
    });
  };

  handleDetailVisible = flag => {
    this.setState({
      detailVisible: !!flag,
    });
  };

  render() {
    const { visible, detailVisible } = this.state;
    const dataItem = this.props.data;
    const files = dataItem.files || [];
    return (
      <div className="form-open">
        <Card title="工资详情">
          <DescriptionList size="large" col={3}>
            <Description term="工资金额">{dataItem.price}元</Description>
            <Description term="工资公司">{dataItem.company}</Description>
            <Description term="工资凭证">
              {files.length > 0 ? (
                <a onClick={() => queryFilePreview(files[0])}> {files[0].name}</a>
              ) : (
                ''
              )}
            </Description>
            <Description term="预算来源">
              <a onClick={() => this.handleVisible(true)}>发放详情</a>
            </Description>
            <Description term="工资明细">
              <a onClick={() => this.handleDetailVisible(true)}>详情</a>
            </Description>
          </DescriptionList>
          <DescriptionList size="large" col={2}>
            <Description term="工资说明">{dataItem.reason}</Description>
          </DescriptionList>
        </Card>
        {visible ? (
          <ModalApportion
            onCancel={this.handleVisible}
            details={dataItem.apportion.details}
            visible={visible}
          />
        ) : null}
        {detailVisible ? (
          <ModalDetailTable
            onCancel={this.handleDetailVisible}
            visible={detailVisible}
            {...this.props}
          />
        ) : null}
      </div>
    );
  }
}

export default Open;



// WEBPACK FOOTER //
// ./src/components/hr/wage/FormOpen.js